import Notiflix from 'notiflix';

export const initializeNotiflix = () => {
  Notiflix.Report.init({
    width: '350px',
    borderRadius: '8px',
    titleFontSize: '18px',
    messageFontSize: '14px',
    svgSize: '40px',
    backOverlay: true,
    backgroundColor: `#12242e`,
    backOverlayColor: 'rgba(0, 0, 0, 0.5)',
    success: {
      svgColor: '#28a745',
      titleColor: '#FFFFFF',
      messageColor: '#FFFFFF',
      buttonBackground: '#155724',
      buttonColor: '#FFFFFF',
      backOverlayColor: 'rgba(0, 0, 0, 0.5)',
    },
    failure: {
      svgColor: '#D2122E',
      titleColor: '#FFFFFF',
      messageColor: '#e74c3c',
      buttonBackground: '#cde8f1',
      buttonColor: '#000000',
      backOverlayColor: 'rgba(0,0,0,0.7)',
    },
    info: {
      svgColor: '#FFDD3C',
      titleColor: '#e5c636',
      messageColor: '#FFFFFF',
      buttonBackground: '#ffdd3c',
      buttonColor: '#000',
      backOverlayColor: 'rgba(0, 0, 0, 0.5)',
    },
    warning: {
      svgColor: '#f39c12',
      titleColor: '#856404',
      messageColor: '#856404',
      buttonBackground: '#fff3cd',
      buttonColor: '#856404',
    },
  });
};

/**
 * Show Notiflix Notification with Optional Auto-Close
 * @param {string} type - Notification type ('success', 'failure', 'info', 'warning')
 * @param {string} title - Notification title
 * @param {string} message - Notification message
 * @param {string} buttonText - Button text (default: 'OK')
 * @param {number} [timeout] - Optional auto-close time (milliseconds)
 */
export const showNotiflixNotification = (type, title, message, buttonText = 'OK', timeout) => {
  // Show the notification
  switch (type) {
    case 'success':
      Notiflix.Report.success(title, message, buttonText);
      break;
    case 'failure':
      Notiflix.Report.failure(title, message, buttonText);
      break;
    case 'info':
      Notiflix.Report.info(title, message, buttonText);
      break;
    case 'warning':
      Notiflix.Report.warning(title, message, buttonText);
      break;
    default:
      console.error('Invalid Notiflix type');
      return;
  }

  // If a timeout is provided, simulate clicking the "OK" button after the timeout
  if (timeout) {
    setTimeout(() => {
      const button = document.querySelector('.notiflix-report-button');
      if (button) {
        (button as HTMLButtonElement).click(); // Simulates user clicking the close button
      }
    }, timeout);
  }
};
